export const FETCH_IR_RECOVERY_POINTS_START = "FETCH_IR_RECOVERY_POINTS_START";
export const FETCH_IR_RECOVERY_POINTS_SUCCESS =
  "FETCH_IR_RECOVERY_POINTS_SUCCESS";
export const FETCH_IR_RECOVERY_POINTS_FAILURE =
  "FETCH_IR_RECOVERY_POINTS_FAILURE";
export const UPDATE_IR_RECOVERY_POINT_SUCCESS =
  "UPDATE_IR_RECOVERY_POINT_SUCCESS";
export const CHANGE_IR_RECOVERY_POINT = "CHANGE_IR_RECOVERY_POINT";
export const CLEAR_IMAGE_RESTORE = "CLEAR_IMAGE_RESTORE";

export const STORE_IR_REQUEST_PARAMS = "STORE_REQUEST_PARAMS";
export const FETCH_UPDATED_VOLUMES = "FETCH_UPDATED_VOLUMES";
export const TOGGLE_VOLUME_IMAGE_RESTORE = "TOGGLE_VOLUME_IMAGE_RESTORE";
export const POPULATE_UPDATED_VOLUMES = "POPULATE_UPDATED_VOLUMES";
export const CHANGE_TARGET_VOLUME = "CHANGE_TARGET_VOLUME";
export const INITIATE_IMAGE_RESTORE = "INITIATE_IMAGE_RESTORE";
export const MACHINE_OFFLINE_IR = "MACHINE_OFFLINE_IR";
export const CHANGE_IMAGE_RESTORE_TARGET_MACHINE =
  "CHANGE_IMAGE_RESTORE_TARGET_MACHINE";
